// extracted by mini-css-extract-plugin
module.exports = {"button":"toggle-button_button__h7Tpu","selected":"toggle-button_selected__8px2I","toggleButton":"toggle-button_toggleButton__47rmj toggle-button_button__h7Tpu"};